import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {Icons, shortcuts} from '@/framework/static/shortcuts';
import {SwiperSlide} from 'swiper/react';

interface IProps {
    isAuthorize: boolean;
    onOpenLoginModal: () => void;
}

function ShortcutSwiper({isAuthorize, onOpenLoginModal}: Readonly<IProps>) {
    return (
        <div className="rounded-[20px] bg-white px-8 py-[6px]">
            <CustomSwiper
                hasNavigation
                slidesPerView={7}
                spaceBetween={32}
                buttonPrevClassName="bg-transparent shadow-none -left-8 hover:opacity-80"
                buttonNextClassName="bg-transparent shadow-none -right-8 hover:opacity-80"
                type="shortcut">
                {shortcuts.map((icon: Icons) => (
                    <SwiperSlide key={icon.title} className="flex items-center justify-center">
                        {!isAuthorize && icon.key === 'tra_cuu_don_hang' ? (
                            <button
                                aria-label="Mở đăng nhập"
                                className="flex flex-col items-center justify-start gap-2 transition-opacity hover:opacity-80"
                                onClick={onOpenLoginModal}
                                style={{cursor: 'pointer'}}>
                                <div className="flex h-[50px] w-[50px] items-center justify-center rounded-full border border-KPZ_divider">
                                    <Image
                                        src={icon.image}
                                        alt={`${icon.title} icon`}
                                        width={icon.size}
                                        height={0}
                                        className="h-auto"
                                        priority={true}
                                        style={{height: 'auto'}}
                                    />
                                </div>
                                <p className="text-center text-sm font-normal text-KPZ_text_1st">{icon.title}</p>
                            </button>
                        ) : (
                            <Link
                                href={icon.url}
                                className="flex flex-col items-center justify-start gap-2 transition-opacity hover:opacity-80">
                                <div className="flex h-[50px] w-[50px] items-center justify-center rounded-full border border-KPZ_divider">
                                    <Image
                                        src={icon.image}
                                        alt={`${icon.title} icon`}
                                        width={icon.size}
                                        height={0}
                                        className="h-auto"
                                        priority={true}
                                    />
                                </div>
                                {icon.key === 'doi_tra_15_ngay' ? (
                                    <p className="flex flex-col text-center text-sm font-normal text-KPZ_text_1st">
                                        <span>Đổi trả</span>
                                        <span>15 ngày</span>
                                    </p>
                                ) : (
                                    <p className="text-center text-sm font-normal text-KPZ_text_1st">{icon.title}</p>
                                )}
                            </Link>
                        )}
                    </SwiperSlide>
                ))}
            </CustomSwiper>
        </div>
    );
}

export default ShortcutSwiper;
